import { Navigate } from 'react-router-dom';
import { useOptimizelyFlag } from '../../../common/hooks/useOptimizelyFlag';
import { MembershipsPageFlag } from '../../../common/OptimizelyFlagsConstants';
import { AccessResource, useHasAccess } from '../../../common/hooks/useHasAccess';

/**
 * Dynamic redirect for /myaccount based on MembershipsPageFlag
 * Redirects to memberships if enabled and the member's tier can see it,
 * otherwise to settings if the member can
 * see it, otherwise preferences - which every member/org/tier can access - so
 * an SN member (who cannot see settings) doesn't land on a 404.
 */
export default function MyAccountDefaultRedirect() {
  const {
    decision: membershipsPageDecision,
    isDecisionReady: isMembershipsPageDecisionReady,
  } = useOptimizelyFlag({
    flag: MembershipsPageFlag,
  });
  const hasMembershipsPageAccess = useHasAccess(AccessResource.MembershipsPage);
  const hasAccountSettingsPageAccess = useHasAccess(AccessResource.AccountSettingsPage);

  // While the decision is loading, don't redirect yet
  if (!isMembershipsPageDecisionReady) {
    return null;
  }

  const defaultPath = (() => {
    if (membershipsPageDecision?.enabled && hasMembershipsPageAccess) return 'memberships';
    if (hasAccountSettingsPageAccess) return 'settings';
    return 'preferences';
  })();
  return <Navigate to={defaultPath} replace />;
}
